var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: function () {
        return _vm.path = _vm.buildPath();
      },
      expression: "() => path = buildPath()"
    }],
    class: {
      p: _vm.padWaveHeight,
      m: _vm.marginWaveHeight
    },
    style: {
      'clip-path': _vm.path
    }
  }, [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }